<header [ngClass]="{ 'border-bottom border-secondary': border }" class="mb-6 flex flex-wrap items-center gap-2 pb-4">
  <ng-content select="[heading]"></ng-content>
  <section
    #controls
    [ngClass]="{ 'inline-flex flex-wrap items-center gap-4': isControlsSectionShown }"
    [hidden]="!isControlsSectionShown"
  >
    <ng-content select="[controls]"></ng-content>
  </section>
</header>
